export default "__VITE_ASSET__XIkHNd_l__"